<template>
  <div class="page">
    <form class="card" @submit.prevent="onSubmit">
      <div class="login-brand">
        <img
          src="@/assets/icon/tech-center-icon.jpg"
          alt="부산광역시교육청 로고"
        />
        <div>
          <h1>테크센터 관리자</h1>
          <p>(주) 디아이앤씨</p>
        </div>
      </div>
      <label class="field">
        <span>아이디</span>
        <input v-model.trim="id" autocomplete="username" />
      </label>

      <label class="field">
        <span>비밀번호</span>
        <input v-model="pw" type="password" autocomplete="current-password" />
      </label>

      <button class="btn" type="submit">로그인</button>
      <div>
        <small class="error">{{ errMsg }}</small>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { memberApi } from "@/api";

const router = useRouter();

const id = ref("");
const pw = ref("");
const errMsg = ref("");

async function onSubmit() {
  const res = await memberApi.login(id.value, pw.value);
  if (res) {
    errMsg.value = "";
    router.replace("/admin/time");
  } else {
    errMsg.value = "아이디 또는 비밀번호가 틀렸습니다.";
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: var(--admin-content-bg);
  font-family: Inter, Pretendard, "Noto Sans KR", system-ui, sans-serif;
}
.card {
  width: min(420px, 100%);
  background: #fff;
  border: 1px solid var(--admin-line);
  border-radius: 0;
  padding: 28px;
  display: grid;
  gap: 16px;
  box-shadow: none;
}
.login-brand {
  display: flex;
  align-items: center;
  gap: 15px;
  padding-bottom: 20px;
  margin-bottom: 2px;
  border-bottom: 1px solid #ececec;
}
.login-brand img {
  width: 66px;
  height: 66px;
  object-fit: contain;
  border: 1px solid var(--admin-line-light);
  border-radius: 0;
}
.login-brand h1 {
  margin: 3px 0;
  font-size: 23px;
  letter-spacing: -0.05em;
}
.login-brand p {
  margin: 0;
  color: #777;
  font-size: 12px;
}
.field {
  display: grid;
  gap: 6px;
  color: #555;
  font-size: 13px;
  font-weight: 650;
}
.field input {
  min-height: 42px;
  border: 1px solid var(--admin-line);
  border-radius: 0;
  padding: 9px 12px;
  outline: none;
}
.field input:focus {
  border-color: #171717;
  box-shadow: none;
  outline: 2px solid #171717;
  outline-offset: 1px;
}
.btn {
  border: 1px solid #111;
  border-radius: 0;
  min-height: 42px;
  padding: 9px 14px;
  background: #111;
  color: #fff;
  font-weight: 750;
  cursor: pointer;
  transition: background 0.16s ease, border-color 0.16s ease,
    transform 0.08s ease;
}
.btn:hover {
  border-color: #333;
  background: #333;
}
.btn:active {
  transform: translateY(1px);
}
.btn:focus-visible {
  outline: 2px solid #171717;
  outline-offset: 2px;
}
.error {
  color: #d93025;
  font-size: 12px;
}
</style>
